import rules from './fieldVisibilityRules';
import { reportTypes } from '../../utils/reports';
import { reportBase, cohorts } from './reportsBase';

export default {
    type: reportTypes.pivot,
    fields: [
        ...reportBase.fields,
        ...cohorts.fields,
        'governanceDimensions',
        'custom_dimensions',
        'xorgMetrics',
        'xorgCohortMetrics',
        'goalsMetrics',
        'goalsForecastMetrics',
        'fileCombinerDimensions',
        'granularityLevels',
        'enrichmentDimensions',
        'trackerData',
        'networkData',
        'discrepancies',
        'videoMetrics',
        'sourceAttributionType',
        'crossDeviceDemoCohortType',
        'metadataDimensions',
        'creativeMeasurementDimensions',
        'conversionEvents',
        'appMetrics',
        'webMetrics',
        'utmParamsFields',
        'searchCampaignDimensions',
        'attributionInsightsDimensions',
        'socialEngagementMetrics',
        'assistMetrics',
    ],
    visibleRule: rules[reportTypes.pivot],
    dataSelector: {
        ...reportBase.dataSelector,
        ...cohorts.dataSelector,
        governanceDimensions: 'governanceDimensions',
        custom_dimensions: 'custom_dimensions',
        fileCombinerDimensions: 'fileCombinerDimensions',
        granularityLevels: 'granularityLevels',
        enrichmentDimensions: 'enrichmentDimensions',
        trackerData: 'trackerData',
        networkData: 'networkData',
        discrepancies: 'discrepancies',
        videoMetrics: 'videoMetrics',
        metadataDimensions: 'metadataDimensions',
        creativeMeasurementDimensions: 'creativeMeasurementDimensions',
        xorgMetrics: 'xorgMetrics',
        appMetrics: 'appMetrics',
        webMetrics: 'webMetrics',
        utmParamsFields: 'utmParamsFields',
        searchCampaignDimensions: 'searchCampaignDimensions',
        attributionInsightsDimensions: 'attributionInsightsDimensions',
        xorgCohortMetrics: 'xorgCohortMetrics',
        sourceAttributionType: 'sourceAttributionType',
        crossDeviceDemoCohortType: 'crossDeviceDemoCohortType',
        selectedTab: 'selectedTab',
        tableDataFormatted: 'reportData',
        mode: 'mode',
        selectedGoal: 'selectedGoal',
        unenriched: 'unenriched',
        admonAlignment: 'admonAlignment',
        isSlimMode: 'isSlimMode',
        selectedSources: 'selectedSources',
        conversionEvents: 'conversionEvents',
        socialEngagementMetrics: 'socialEngagementMetrics',
        assistMetrics: 'assistMetrics',
    },
};
